<div class="root">
  @if (!noBackButton) {
    <fa-icon icon="angle-left" (click)="back()" />
  }
  <div class="title">
    <ng-content />
  </div>
</div>
